import { render, staticRenderFns } from "./classInteraction.vue?vue&type=template&id=3bf1794b&"
import script from "./classInteraction.vue?vue&type=script&lang=js&"
export * from "./classInteraction.vue?vue&type=script&lang=js&"
import style0 from "./classInteraction.vue?vue&type=style&index=0&id=3bf1794b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports